import React, { PureComponent } from 'react';

import DocNodeWithChooser from '../doc-node-with-chooser';

export default class DocUnorderedList extends PureComponent {
    handleMenuAction = type => {
        this.props.onNodeChange && this.props.onNodeChange(this.props.element, type);
    }

    render() {
        const { attributes, children, element } = this.props;

        return (
            <DocNodeWithChooser current={element.type} element={attributes.ref.current} items={this.props.menuItems} depth={1} onAction={this.handleMenuAction}>
                <ul {...attributes} className="doc-node">{children}</ul>
            </DocNodeWithChooser>
        )
    }
}
